import Loadable from 'react-loadable';
import Loading from '../Loading';

export default Loadable({
  loader: () =>
    import(/* webpackChunkName: "Boardroom" */ '../../components/Boardroom'),
  loading: Loading(),
});
